import AxiosClient from "../../../services/axios.services";

class MapaCarreraServices {
  getMapaCarreraCursos = (params) =>
    AxiosClient.get(
      "/api/app/carrera_diagrama/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getMapaCarreraCompetencias = (params) =>
    AxiosClient.get(
      "/api/app/carrera_diagrama_competencia/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

}

export default new MapaCarreraServices();
